// src/services/storage.js

export const storage = {
  getBool(key, fallback = false) {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return raw === 'true';
  },

  setBool(key, value) {
    localStorage.setItem(key, value ? 'true' : 'false');
  },

  getJson(key, fallback) {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    try {
      return JSON.parse(raw);
    } catch {
      return fallback;
    }
  },

  setJson(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  getString(key, fallback = null) {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : raw;
  },

  setString(key, value) {
    localStorage.setItem(key, value);
  },

  remove(...keys) {
    keys.forEach((k) => localStorage.removeItem(k));
  },
};
